import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";

interface UpdateEmailModalProps {
  onClose: () => void;
  shouldShow: boolean;
}

interface UpdateEmailModalValues {
  email: string;
}

const UpdateEmailModalSchema = yup.object().shape({
  email: yup.string().email("Please enter a valid email").required("Email is required"),
});

export default function UpdateEmailModal({ onClose, shouldShow }: UpdateEmailModalProps) {
  const { control, errors, handleSubmit } = useForm<UpdateEmailModalValues>({
    resolver: yupResolver(UpdateEmailModalSchema),
    defaultValues: {
      email: "",
    },
  });

  const userApi = useUserApi();
  const userAction = useAppUserAction();
  const toast = useToaster();

  const onSubmit = (values: UpdateEmailModalValues) => {
    const params = {
      email: values?.email,
    };
    userApi.callUpdateEmail(
      params,
      (_message: any, resp: any) => {
        userAction.updateEmail(resp.email);
        onClose();
      },
      (error: any) => {
        console.error("Update email error", error);
        if (error?.data?.errors) {
          const errorMessages = Object.values(error.data.errors).flat();
          errorMessages.forEach((msg: any) => toast.error(msg));
        } else if (error?.message) {
          toast.error(error.message);
        } else {
          toast.error(error.toString() || "An error occurred while updating email");
        }
      },
    );
  };

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <h4 className="signin-title mb-2">Enter your email</h4>
            <div className="mb-3">
              {/* <label className="form-label">Email</label> */}
              <Controller
                control={control}
                name="email"
                render={({ onChange, onBlur, value, name: _name, ref }) => (
                  <FormTextInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.email}
                    placeholder="Email"
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button type="button" className="btn btn-primary send-code-btn mb-3" onClick={handleSubmit(onSubmit)}>
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
